/* istanbul ignore file */
import styled, { css } from 'styled-components';

export type StyleProps = {
  $palette: 'blue' | 'purple';
};

export const Learnable = styled.div(
  ({ theme }) => css`
    width: 100%;
    padding-top: ${theme.sz.s4};
    padding-bottom: ${theme.sz.s4};
    padding-left: ${theme.sz.s6};
    padding-right: ${theme.sz.s6};
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 0;
    border-radius: ${theme.bo.medium};
    border-style: solid;
    border-width: 3px;
    color: #e8e5df;
    font-family: ${theme.DEPRECATED_ty.openSans};

    @media (min-width: ${theme.sz.md}) {
      flex-direction: row;
      align-items: center;
      gap: ${theme.sz.s6};
    }
  `,
);

export const Learnables = styled.div<StyleProps>(
  ({ theme, $palette }) => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: ${theme.sz.s4};
    overflow-y: auto;

    /* hides scrollbar for Firefox */
    scrollbar-width: none;
    /* hides scrollbar for rest browsers */
    &::-webkit-scrollbar {
      display: none;
    }

    ${Learnable} {
      ${
        $palette === 'blue' &&
        css`
          background-color: ${theme.co.secondary0};
          border-color: ${theme.co.secondary20};
        `
      }

      ${
        $palette === 'purple' &&
        css`
          background-color: ${theme.co.secondary0};
          border-color: ${theme.co.secondary60};
        `
      }
    }
  `,
);

export const Source = styled.div(
  ({ theme }) => css`
    flex: 1;
    word-break: break-word;
    font-size: ${theme.DEPRECATED_ty.small};
    line-height: 150%;
    /* or 21px */
  `,
);

export const Target = styled.div(
  ({ theme }) => css`
    width: 100%;
    word-break: break-word;
    font-size: ${theme.DEPRECATED_ty.medium};
    font-weight: ${theme.DEPRECATED_ty.bold};
    line-height: 130%;
    /* or 21px */

    @media (min-width: ${theme.sz.md}) {
      width: 140px;
      min-width: 140px;
      line-height: ${theme.DEPRECATED_ty.larger};
    }
  `,
);
